module.exports = __webpack_public_path__ + "static/media/proceed-dialog-success.06ba9770.svg";